import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { getBaseUrl } from '@/redux/modules/config';
import { GlobalState } from '@/redux/rootReducer';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import { Location } from 'history';
import PageTitle from '@/components/PageTitle/PageTitle';
import styles from './NotFound.module.scss';

type OwnProps = {
    location: Location;
};

const mapStateToProps = (state: GlobalState, { location }: OwnProps) => {
    const { pathname } = location;
    return {
        baseUrl: getBaseUrl(state),
        pathname,
    };
};

type ReduxProps = {
    baseUrl: string;
    pathname: string;
};

type Props = OwnProps & ReduxProps;

class NotFound extends PureComponent<Props> {
    render() {
        const { baseUrl, pathname } = this.props;
        const url = `${baseUrl}${pathname}`;
        return (
            <div className={`${styles.container} container`}>
                <PageTitle title="404" />
                <p>
                    <FormattedMessage id="sorry_we_cant_find" />
                </p>
                {Boolean(pathname) && (
                    <p>
                        <i className={styles.url}>
                            &quot;
                            {url}
                            &quot;
                        </i>
                    </p>
                )}
                <Link to={baseUrl}>www.liveauctioneers.com</Link>
            </div>
        );
    }
}

export default connect(mapStateToProps)(NotFound);
